module.exports = __webpack_public_path__ + "static/media/icon_system_social_twitter.4decd3f4.svg";